function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQboIconCircle = function SvgQboIconCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    style: {
      fill: "#2ca01c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.331 12.22c-4.296 0-7.78 3.484-7.78 7.78s3.477 7.774 7.78 7.774h1.112v-2.886h-1.112c-2.697 0-4.888-2.191-4.888-4.888s2.19-4.888 4.888-4.888h2.671v15.112a2.888 2.888 0 0 0 2.886 2.886V12.22h-5.557zm13.338 15.554c4.296 0 7.78-3.484 7.78-7.774s-3.477-7.774-7.78-7.774h-1.111v2.886h1.111c2.697 0 4.888 2.191 4.888 4.888s-2.191 4.888-4.888 4.888h-2.671V9.776a2.888 2.888 0 0 0-2.886-2.886v20.884h5.557z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgQboIconCircle;